<template>
    <div class="sub-visual">
		<v-container>
			<v-row align="end">
				<v-col cols="12" md="8" lg="7">
					<h2 class="tit--lg line-height-1 color-white" data-aos="fade-up"><span>{{visual}}</span></h2>
				</v-col>
				<v-col cols="12" md="4" lg="5" class="d-none d-md-block">
					<div class="pl-36">
						<v-img src="/images/sub/visual/sv-icon.png" max-width="360"></v-img>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>

export default{
    props : {
        visual : {type :String, default : ""}
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>